import React, { useState } from 'react';
import Input from '../../1_Atoms/Forms/Input/Input';
import Button from '../../1_Atoms/Button/Button';
import FormGroup from '../../2_Molecules/FormGroup/FormGroup';
import { handleRequest } from '../../../utils/httpRequest';
import { getEndpointUrl } from '../../../utils/endPoints';
import Form from '../../2_Molecules/Form/Form';
import { languageController } from '../../../controllers/language/languageController';
import { useForm } from '../../../hooks/useForm';
import Select from '../../1_Atoms/Forms/Select/Select';
import Textarea from '../../1_Atoms/Forms/Textarea/Textarea';
import FormContainer from '../../2_Molecules/FormContainer/FormContainer';
import { convertLangCodeToSingleLetter } from '../../../utils/helpers';
import formLang from '../../../controllers/language/shared/form';
import FormConfirmation from '../../2_Molecules/FormConfirmation/FormConfirmation';

function ContactUs({ formExtraParams }) {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [formError, setFormError] = useState(null)

  const { language, formSubmitButtonText } = formExtraParams

  const initState = {
    firstname: '',
    lastname: '',
    email: '',
    postalcode: '',
    vin: '',
    subject: '',
    message: '',
    language: convertLangCodeToSingleLetter(language),
  }

  const validations = {
    firstname: ['required', 'name', 'nameMaxMin'],
    lastname: ['required', 'name', 'nameMaxMin'],
    email: ['required', 'email'],
    postalcode: ['required', 'postalcode'],
    vin: ['vin', 'isAlphaNumeric'],
    subject: ['required'],
    message: ['required'],
  }

  const { handleSubmit, handleChange, data, errors, setData } = useForm({
    initState,
    validations,
    // Send the form data if validated
    onSubmit: async () => {
      try {
        const endPointUrl = getEndpointUrl('contact');
        const res = await handleRequest('post', endPointUrl, { ...data, vin: data.vin ? data.vin : null });
        if (res.Success) {
          setIsSubmitted(true);
          setData(initState)
        } else {
          setFormError(res.state ? res.state : res.Errors[0])
        }
      } catch (err) {
        console.log(err)
      }
    },
  })

  const { firstname, lastname, email, postalcode, vin, subject, message } = data;

  return (
    <FormContainer
      isSubmitted={isSubmitted}
      confirmation={(
        // TODO: Add the right copies when it's created.
        <FormConfirmation 
          heading={'Lorem Ipsum'}
          subHeading={'Lorem Ipsum is simply dummy text of the printing and typesetting industry.'}
          buttonLabel={'Submit another form'}
          onClick={() => setIsSubmitted(false)}
        />
      )}
      className="mz-contact-us"
      data-mz-form-type="ContactUs"
    >
      <Form
        type="contact-us"
        onSubmit={handleSubmit}
        isDark={false}
        noValidate={true}
        requiredFieldsHelperText={true}
        errorMessage={formError}
      >
        <FormGroup md={2}>
          <Input
            type="text"
            name="firstname"
            label={languageController.getFormCopy('label', 'firstname')}
            id="contact-firstname"
            value={firstname}
            isRequired={true}
            errorMessage={errors.firstname}
            onChange={handleChange}
            maxLength={50}
          />
          <Input
            type="text"
            name="lastname"
            label={languageController.getFormCopy('label', 'lastname')}
            id="contact-lastname"
            value={lastname}
            isRequired={true}
            errorMessage={errors.lastname}
            onChange={handleChange}
            maxLength={50}
          />
        </FormGroup>
        <Input
          type="email"
          name="email"
          label={languageController.getFormCopy('label', 'email')}
          id="contact-email"
          value={email}
          isRequired={true}
          errorMessage={errors.email}
          onChange={handleChange}
          maxLength={320}
        />
        <FormGroup md={2}>
          <Input
            type="text"
            name="postalcode"
            label={languageController.getFormCopy('label', 'postalcode')}
            id="contact-postalcode"
            value={postalcode}
            isRequired={true}
            errorMessage={errors.postalcode}
            onChange={handleChange}
            maxLength={7}
          />
        </FormGroup>
        <Input
          type="text"
          name="vin"
          label={languageController.getFormCopy('label', 'vin')}
          id="contact-vin"
          value={vin}
          isRequired={false}
          errorMessage={errors.vin}
          onChange={handleChange}
          maxLength={17}
        />
        <Select
          name="subject"
          label={languageController.getFormCopy('label', 'subject')}
          id="contact-email-subject"
          value={subject}
          isRequired={true}
          errorMessage={errors.subject}
          onChange={handleChange}
          placeholder={languageController.getFormCopy('placeholder', 'subject')}
          options={formLang.select.emailSubjects.map(subject => ({
            value: subject[language],
            label: subject[language],
          }))}
        />
        <Textarea
          name="message"
          label={languageController.getFormCopy('label', 'message2500')}
          id="contact-message"
          value={message}
          isRequired={true}
          errorMessage={errors.message}
          onChange={handleChange}
          maxLength={2500}
          rows={5}
        />
        <Button
          type="submit"
          className="mz-btn--primary mz-btn--red"
          label={formSubmitButtonText ? formSubmitButtonText : languageController.getCopy('contact', 'submit')}
        />
      </Form>
    </FormContainer>
  )
}

export default ContactUs
